import { render, staticRenderFns } from "./DashboardRevenueSummary.vue?vue&type=template&id=13e653b4&scoped=true"
import script from "./DashboardRevenueSummary.vue?vue&type=script&lang=js"
export * from "./DashboardRevenueSummary.vue?vue&type=script&lang=js"
import style0 from "./DashboardRevenueSummary.vue?vue&type=style&index=0&id=13e653b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e653b4",
  null
  
)

export default component.exports